<div class="d-flex justify-content-center w-100"
     (deferLoad)="loadAvatars()" [style.height.px]="100">
  <carousel *ngIf="isLoaded$ | async" [width]="100" [arrows]="(avatars$ | async)?.length > 0" [height]="100"
            [cellsToShow]="1" [cellWidth]="100" [cellsToScroll]="1">

    <div class="carousel-cell">
      <app-avatar
        [Service]="Service"
        [id]="Service.arProfile?.id"
        [class.avatar-online]="true"
        [type]="'private'"
        [force]="true"
        [avatar]="Service.arProfile?.avatar"
        [avatarFileId]="Service.arProfile?.avatar_file_id"
        [avatarFileUniqueId]="Service.arProfile?.avatar_file_unique_id"
        class="avatar avatar-xl"
      >
        <nz-upload
          nzAccept="image/jpeg,image/png,image/jpg"
          class="avatar-uploader"
          [nzAction]="uploadUrl"
          nzName="avatar"
          nzListType="picture-card"
          [nzHeaders]="avatarHeaders"
          [nzShowUploadList]="false"
          (nzChange)="handleChangeAvatar($event)"
        >
          <ng-container>
            <i-feather name="camera" class="icon-md text-white"></i-feather>
            <!-- <div class="ant-upload-text">Upload</div>-->
          </ng-container>
        </nz-upload>
      </app-avatar>
    </div>

    <div *ngFor="let avatar of (avatars$ | async)" class="carousel-cell">
      <app-avatar
        [Service]="Service"
        [id]="Service.arProfile?.id"
        [type]="'private'"
        [force]="true"
        [avatar]="avatar?.avatar"
        [avatarFileId]="avatar.file_id"
        [avatarFileUniqueId]="avatar.file_unique_id"
        class="avatar avatar-xl"
      >
        <div (click)="removeAvatar(avatar)" class="remove-avatar">
          <i-feather name="trash-2" class="icon-md text-white"></i-feather>
        </div>
      </app-avatar>
    </div>
  </carousel>
</div>
